import React from 'react';
import { object, string } from 'prop-types';
import classNames from 'classnames';
import { getUserTier } from './userTierUtils';
import css from './UserTierBadge.module.css';

/**
 * UserTierBadge — displays the user's tier badge inline.
 *
 * Usage (in ProfilePage, AuthorCard, etc.):
 *   <UserTierBadge user={authorUser} />
 *
 * Shows nothing for 'basic' tier (no badge for default tier).
 */
const UserTierBadge = ({ user, className }) => {
  const tier = getUserTier(user);
  if (!tier || tier.key === 'basic') return null;

  return (
    <span
      className={classNames(css.badge, className)}
      style={{ color: tier.color, background: tier.bg }}
    >
      {tier.label}
    </span>
  );
};

UserTierBadge.defaultProps = { className: null, user: null };
UserTierBadge.propTypes = { user: object, className: string };

export default UserTierBadge;
